import { Box, SxProps, Theme } from '@mui/system';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  sx?: SxProps<Theme>;
}

export const TabPanelContainer: React.FC<TabPanelProps> = ({
  children,
  index,
  value,
  sx,
}) => {
  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      sx={{ width: '100%', ...sx }}
    >
      {value === index && <Box>{children}</Box>}
    </Box>
  );
};
